import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { User } from 'lib-shared-types-api';

// eslint-disable-next-line no-restricted-imports
import { ToggleUserCsatExclusionButtonListItem } from 'components/shared/toggleUserCsatExclusionButtonListItem';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { AddContactAttributesAction } from './components/addContactAttributesAction/addContactAttributesAction';
import { BanUnbanContactAction } from './components/banUnbanContactAction/banUnbanContactAction';
import { EditContactAction } from './components/editContactAction/editContactAction';
import { MergeContactsAction } from './components/mergeContactsAction/mergeContactsAction';

export type MoreDropdownActionProps = {
  /** The current user object */
  user: User;
};

/** More dropdown with hidden actions */
export const MoreDropdownAction = ({
  user,
}: MoreDropdownActionProps): JSX.Element => {
  const hasBanAccess = useHasAccess('contact.ban');
  const hasCustomAttributeAccess = useHasAccess('contact.custom_attribute');
  const hasMergeAccess = useHasAccess('contact.merge');
  const flags = useFeatureFlag(['agnostic-csat-settings']);

  return (
    <DropdownButton
      data-testid="contact-more-dropdown"
      icon="dots-v"
      buttonProps={{
        variant: 'tertiary',
      }}
      dropdownProps={{
        closeOnBlur: true,
      }}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              <EditContactAction user={user} toggleDropdown={toggleDropdown} />

              {hasMergeAccess && (
                <MergeContactsAction
                  user={user}
                  toggleDropdown={toggleDropdown}
                />
              )}

              {hasCustomAttributeAccess && (
                <AddContactAttributesAction
                  user={user}
                  toggleDropdown={toggleDropdown}
                />
              )}

              {hasBanAccess && user.type === 'contact' && (
                <BanUnbanContactAction
                  user={user}
                  toggleDropdown={toggleDropdown}
                />
              )}

              {flags.agnosticCsatSettings && user.type === 'contact' && (
                <ToggleUserCsatExclusionButtonListItem
                  user={user}
                  onToggle={toggleDropdown}
                />
              )}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
    />
  );
};
